module.exports = __webpack_public_path__ + "img/report_icon.c8d02648.svg";